import React from 'react';

export type StatPillTone = 'primary' | 'info' | 'warning' | 'danger' | 'success' | 'neutral';

interface StatPillProps {
  value: React.ReactNode;
  label: string;
  tone?: StatPillTone;
  className?: string;
  onClick?: () => void;
}

const TONE_MAP: Record<StatPillTone, { container: string; value: string }> = {
  primary: {
    container: 'border-primary-200 dark:border-primary-700 bg-primary-50 dark:bg-primary-900/20',
    value: 'text-gray-900 dark:text-white',
  },
  info: {
    container: 'border-info-200 dark:border-info-700 bg-info-50 dark:bg-info-900/20',
    value: 'text-info-600 dark:text-info-400',
  },
  warning: {
    container: 'border-warning-200 dark:border-warning-700 bg-warning-50 dark:bg-warning-900/20',
    value: 'text-warning-600 dark:text-warning-400',
  },
  danger: {
    container: 'border-error-200 dark:border-error-700 bg-error-50 dark:bg-error-900/20',
    value: 'text-error-600 dark:text-error-400',
  },
  success: {
    container: 'border-success-200 dark:border-success-700 bg-success-50 dark:bg-success-900/20',
    value: 'text-success-600 dark:text-success-400',
  },
  neutral: {
    container: 'border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/60',
    value: 'text-gray-900 dark:text-white',
  },
};

const StatPill: React.FC<StatPillProps> = ({ value, label, tone = 'neutral', className = '', onClick }) => {
  const t = TONE_MAP[tone];
  const Tag = onClick ? 'button' : 'div';
  return (
    <Tag
      onClick={onClick}
      className={`flex flex-col items-center justify-center px-1.5 py-2.5 rounded-xl border text-center transition-colors ${t.container} ${onClick ? 'hover:opacity-90 cursor-pointer' : ''} ${className}`}
    >
      <span className={`text-lg sm:text-xl font-bold leading-none tabular-nums ${t.value}`}>
        {value}
      </span>
      <span className="text-[9px] sm:text-[10px] font-semibold tracking-[0.08em] uppercase mt-1 text-gray-500 dark:text-gray-400">
        {label}
      </span>
    </Tag>
  );
};

export default StatPill;
